export default __webpack_public_path__ + "d8efcc53732f41727f3ef43d6ba73194.woff2";